export class SkeletonLoaderRepository {
    static get companiesLayout() {
        return {
            rows: [
                {
                    columns: [
                        {
                            colSize: 'col-sm-4',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 3,
                                }
                            ]
                        },
                        {
                            colSize: 'col-sm-4',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 3,
                                }
                            ]
                        },
                        {
                            colSize: 'col-sm-4',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 3,
                                }
                            ]
                        },
                    ]
                },
            ]
        }
    }

    static get singleCompanyLayout() {
        return {
            rows: [
                {
                    columns: [
                        {
                            colSize: 'col-sm-8',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 6,
                                }
                            ]
                        },
                        {
                            colSize: 'col-sm-4',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 6,
                                }
                            ]
                        },
                    ]
                },
            ]
        }
    }

    static get usersListLayout() {
        return {
            rows: [
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    }

    static get documentTestLayout() {
        return {
            rows: [
                {
                    columns: [
                        {
                            colSize: 'offset-sm-3 col-sm-6',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 1,
                                }
                            ]
                        }
                    ]
                },
                {
                    columns: [
                        {
                            colSize: 'col-12',
                            innerColumns: [
                                {
                                    colSize: 'col-12',
                                    height: 8,
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    }
}